import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import BaseText from '../BaseText';
import RowView from '../RowView';
import { Color, CommonProperties } from '../../styles';
import Icon from '../Icon';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';

const TravelerSafety = ({ lastDateCheck, onPress }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('DutyofCareCheckedIn');
  return (
    <TouchableOpacity onPress={onPress}>
      <View style={styles.container}>
        <BaseText style={styles.text}>{t(tKey('TravelerSafety'))}</BaseText>
        <RowView style={styles.innerContainer}>
          <Icon style={styles.icon} name="mark" color={Color.primary} />
          <View>
            <BaseText>{t(tKey('CheckInMyLocationForDutyOfCare'))}.</BaseText>
            {lastDateCheck && lastDateCheck !== '0001-01-01T00:00:00' ? (
              <BaseText style={styles.text}>
                {t(tKey('CheckedIn'))}: {moment(lastDateCheck).format('MM/DD/YY @ h:mm a')}
              </BaseText>
            ) : null}
          </View>
        </RowView>
      </View>
    </TouchableOpacity>
  );
}; // 7/20/20 @ 8:03a

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    ...CommonProperties.p3,
  },
  innerContainer: {
    ...CommonProperties.centerItems,
    ...CommonProperties.mt2,
  },
  text: {
    color: Color.grayText,
    ...CommonProperties.small,
  },
  icon: {
    fontSize: 28,
    ...CommonProperties.px3,
  },
});

export default TravelerSafety;
